import React, { useState } from 'react';
import ContactModal from './ContactModal';

const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <header className='fixed top-0 left-0 right-0 z-50 py-[27px]'>
        <div className='container mx-auto px-4'>
          <div className='flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-[138px]'>
            {/* Navigation Bar */}
            <div className='backdrop-blur-[5px] bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.5)] rounded-[65px] h-[58px] px-2 sm:px-4 flex items-center justify-center'>
              <div className='flex items-center gap-0'>
                <a
                  href='#home'
                  className='px-3 sm:px-6 h-[61px] flex items-center justify-center text-base sm:text-[20px] font-semibold text-white hover:opacity-80 transition-opacity'
                >
                  Home
                </a>
                <a
                  href='#services'
                  className='px-3 sm:px-6 h-[61px] flex items-center justify-center text-base sm:text-[20px] font-semibold text-white hover:opacity-80 transition-opacity'
                >
                  Services
                </a>
                <a
                  href='#faqs'
                  className='px-3 sm:px-6 h-[61px] flex items-center justify-center text-base sm:text-[20px] font-semibold text-white hover:opacity-80 transition-opacity'
                >
                  FAQs
                </a>
                <button
                  onClick={() => setIsModalOpen(true)}
                  className='px-3 sm:px-6 h-[61px] flex items-center justify-center text-base sm:text-[20px] font-semibold text-white hover:opacity-80 transition-opacity bg-transparent outline-none cursor-pointer'
                >
                  Contact
                </button>
              </div>
            </div>

            {/* Book a Call Button */}
            <button 
              onClick={() => setIsModalOpen(true)}
              className='bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.5)] rounded-[60px] h-[58px] px-4 sm:px-[33px] text-base sm:text-[20px] font-semibold text-white hover:opacity-80 transition-opacity whitespace-nowrap'
            >
              Book a Call
            </button>
          </div>
        </div>
      </header>

      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </>
  );
};

export default Header;
